import { createSelector } from 'reselect';

const substate = (state) => state.policy;

export const selectPolicyAdjustments = () => createSelector(substate, (policyState) => policyState.policyAdjustments);
